import React, { ReactNode, createContext, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { jotpsychTheme } from '../../styles/themes';

type BrandLanguage = {
  brandName: string;
  brandSite: string;
  brandContact: string;
};

// Static brand language - JotPsych only
const brandLanguage: BrandLanguage = {
  brandName: 'JotPsych',
  brandSite: 'jotpsych.com',
  brandContact: 'contact@jotpsych.com',
};

// Theme context type - simplified, no brand switching
type ThemeContextType = {
  brandLanguage: BrandLanguage;
};

const ThemeContext = createContext<ThemeContextType>({
  brandLanguage,
});

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }: { children: ReactNode }) => {
  // Set document title
  document.title = `${brandLanguage.brandName} by SmartScribe — AI-Powered Medical Charting`;

  return (
    <ThemeContext.Provider value={{ brandLanguage }}>
      <ThemeProvider theme={jotpsychTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
